export const CorrectIcon = () => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.5 20.9167C16.2529 20.9167 20.9167 16.253 20.9167 10.5C20.9167 4.74707 16.2529 0.083374 10.5 0.083374C4.74704 0.083374 0.0833435 4.74707 0.0833435 10.5C0.0833435 16.253 4.74704 20.9167 10.5 20.9167ZM15.4032 9.15327C15.81 8.7465 15.81 8.08694 15.4032 7.68013C14.9965 7.27334 14.3369 7.27334 13.9301 7.68013L9.45834 12.1519L8.11158 10.8051C7.70478 10.3984 7.04524 10.3984 6.63844 10.8051C6.23165 11.2119 6.23165 11.8715 6.63844 12.2783L8.72178 14.3616C9.12855 14.7684 9.78814 14.7684 10.1949 14.3616L15.4032 9.15327Z"
                fill="url(#paint0_linear_3_913)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3_913"
                    x1="0.0833435"
                    y1="0.083374"
                    x2="20.9167"
                    y2="20.9167"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.114583" stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.5" />
                </linearGradient>
            </defs>
        </svg>
    );
};
